import { Button } from '@mui/material';
import { Loader, NamedLayoutBlock } from 'src/components';
import { StripeConnectedBanner } from './stripe-connected-banner';
import { StripeSetupBanner } from './stripe-setup-banner';
import { ErrorCard, ErrorText } from './styled';
import { useStripeAccountOnboardStatus } from './use-stripe-account-onboard-status';

export const StripeSettingsView = () => {
  const {
    detailsSubmitted,
    chargesEnabled,
    country,
    email,
    bankAccount,
    payoutSchedule,
    hasAccount,
    loading,
    error,
  } = useStripeAccountOnboardStatus();

  if (loading) {
    return (
      <NamedLayoutBlock title="Stripe">
        <Loader />
      </NamedLayoutBlock>
    );
  }

  if (error) {
    return (
      <NamedLayoutBlock title="Stripe">
        <ErrorCard role="alert">
          <ErrorText>
            We couldn&apos;t load your Stripe account information. Please try again.
          </ErrorText>
          <Button variant="outlined" onClick={() => window.location.reload()}>
            Retry
          </Button>
        </ErrorCard>
      </NamedLayoutBlock>
    );
  }

  return (
    <NamedLayoutBlock title="Stripe">
      {hasAccount ? (
        <StripeConnectedBanner
          bankAccount={bankAccount}
          chargesEnabled={chargesEnabled}
          country={country}
          email={email}
          payoutSchedule={payoutSchedule}
          detailsSubmitted={detailsSubmitted}
        />
      ) : (
        <StripeSetupBanner />
      )}
    </NamedLayoutBlock>
  );
};
